import React from 'react'
import getYouTubeID from 'get-youtube-id'

const YouTube = ({node}) => {
    const id = getYouTubeID(node.url)
    const url = `https://www.youtube.com/embed/${id}`
    if(!id) {
        return (<div></div>)
    }

    return (
        <iframe 
            title="YouTube video"
            className="youtube"
            width="560"
            height="315"
            src={url}
            frameborder="0" 
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
            allowfullscreen>
        </iframe>
    )
}

export default YouTube